// src/components/PsicomotricidadeInfo.tsx
import React from 'react';
import '../../styles/especialidades.css';

const NeurologistaInfo: React.FC = () => (
    <section className="about_psicomotricidade">
        <div className="teste_zoom_two">
            <div className="about_text_psicomotricidade">
                <h2 className='sub_title'><b>Promovendo comunicação, autonomia e qualidade de vida.</b></h2>
                <br />
                <p>A Fonoaudiologia é a ciência que estuda, previne, avalia, diagnostica e trata alterações relacionadas à comunicação humana, envolvendo aspectos da fala, linguagem oral e escrita, voz, audição, motricidade orofacial, deglutição e funções relacionadas.</p>
                <br />
                <p>A atuação do fonoaudiólogo é ampla e abrange todas as fases da vida, desde o acompanhamento do desenvolvimento da linguagem em crianças até o tratamento de alterações vocais ou de deglutição em adultos e idosos. O objetivo principal é favorecer a expressão, a compreensão e o uso funcional da comunicação, promovendo autonomia, inclusão social e bem-estar.</p>
                <br />
                <p><b>Quando procurar um fonoaudiólogo?</b></p>
                <br />
                <p>A Fonoaudiologia é indicada para:</p>
                <br/>
                <li>Crianças com atraso no desenvolvimento da fala e linguagem, distúrbios de aprendizagem ou dificuldades na alfabetização;</li>
                <li>Adolescentes e adultos com alterações na articulação, fluência (gagueira), voz ou linguagem escrita;</li>
                <li>Indivíduos com dificuldades de deglutição (disfagia), respiratórias ou alimentação, inclusive em contextos hospitalares;</li>
                <li>Pessoas com perdas auditivas que necessitam de reabilitação ou adaptação de aparelhos auditivos.</li>
                <br />
                <p><b>Comunicar é viver</b></p>
                <br />
                <p>O acompanhamento fonoaudiológico é fundamental para promover uma comunicação eficaz, segura e saudável, contribuindo significativamente para a qualidade de vida em contextos pessoais, escolares, sociais e profissionais.</p>

            </div>
        </div>
    </section>
);

export default NeurologistaInfo;